var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "material-summary" } }, [
    _c("p", { staticClass: "headline-large black mg mg--b-6 mg--t-2" }, [
      _vm._v(_vm._s(_vm.$t("warrantySticky.materialList.title")))
    ]),
    _c("div", { staticClass: "material-summary__list" }, [
      _c(
        "div",
        { staticClass: "grid" },
        _vm._l(_vm.stateWarrantyMaterialSummary.materials, function(material) {
          return _vm.stateWarrantyMaterialSummary.materials
            ? _c(
                "div",
                { staticClass: "grid__cell grid__cell-md-1 mg mg--b-2" },
                [
                  _c("p", { staticClass: "mg mg--b-1 headline-medium black" }, [
                    _vm._v(_vm._s(material.title))
                  ]),
                  _c("p", { staticClass: "text-small gray mg mg--b-2" }, [
                    _vm._v(
                      _vm._s(material.total_hours) +
                        "h | " +
                        _vm._s(material.total_cost) +
                        "€"
                    )
                  ]),
                  _vm._l(material.items, function(item) {
                    return _c(
                      "div",
                      { staticClass: "material-summary__material mg mg--b-3" },
                      [
                        _c("div", {
                          staticClass: "material-summary__material__img",
                          style: {
                            backgroundImage:
                              "url(" + _vm.getImgPath(item.image) + ")"
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "material-summary__material__info" },
                          [
                            _c("p", { staticClass: "text-medium gray" }, [
                              _vm._v(
                                _vm._s(item.name) +
                                  " " +
                                  _vm._s(
                                    _vm.$tc("common.unit", item.units, {
                                      count: item.units
                                    })
                                  )
                              )
                            ]),
                            item.only_show_total_price
                              ? _c("span", { staticClass: "text-small gray" }, [
                                  _vm._v(_vm._s(item.total_price) + "€")
                                ])
                              : _c("span", { staticClass: "text-small gray" }, [
                                  _vm._v(
                                    _vm._s(item.price_unit) +
                                      "€/u | " +
                                      _vm._s(item.total_price) +
                                      "€"
                                  )
                                ])
                          ]
                        )
                      ]
                    )
                  }),
                  material.show_manpower_price
                    ? _c(
                        "div",
                        {
                          staticClass: "material-summary__material mg mg--b-3"
                        },
                        [
                          _c("div", {
                            staticClass: "material-summary__material__img",
                            style: {
                              backgroundImage:
                                "url(" +
                                _vm.getImgPath("GAG_MANPOWER.png") +
                                ")"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "material-summary__material__info" },
                            [
                              _c("p", { staticClass: "text-medium gray" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "warrantySticky.materialList.manpowerTitle"
                                    )
                                  )
                                )
                              ]),
                              _c("span", { staticClass: "text-small gray" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("floatToFixed")(
                                      material.total_hours_cost /
                                        material.total_hours,
                                      1
                                    )
                                  ) +
                                    "€/u | " +
                                    _vm._s(material.total_hours_cost) +
                                    "€"
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        }),
        0
      ),
      _vm.stateWarrantyMaterialSummary.materials
        ? _c("div", { staticClass: "grid grid--jc-between" }, [
            _c("div", { staticClass: "list list--counter" }, [
              _c("ul", { staticClass: "bg-green" }, [
                _c("li", { staticClass: "mg mg--l-2 mg--r-2" }, [
                  _c("p", { staticClass: "text-medium white mg mg--b-1" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.stateWarrantyMaterialSummary.manpower_hours
                        ) +
                        " h"
                    )
                  ]),
                  _c("p", { staticClass: "text-small white" }, [
                    _vm._v(
                      _vm._s(_vm.$t("warrantySticky.materialList.manpowerTime"))
                    )
                  ])
                ]),
                _c("li", { staticClass: "mg mg--l-2 mg--r-2" }, [
                  _c("p", { staticClass: "text-medium white mg mg--b-1" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.stateWarrantyMaterialSummary.manpower_total_cost
                        ) +
                        " €"
                    )
                  ]),
                  _c("p", { staticClass: "text-small white" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("warrantySticky.materialList.manpowerPrice")
                        )
                    )
                  ])
                ]),
                _c("li", { staticClass: "mg mg--l-2 mg--r-2" }, [
                  _c("p", { staticClass: "text-medium white mg mg--b-1" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.stateWarrantyMaterialSummary.material_total_cost
                        ) +
                        " €"
                    )
                  ]),
                  _c("p", { staticClass: "text-small white" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("warrantySticky.materialList.materials"))
                    )
                  ])
                ]),
                _c("li", { staticClass: "mg mg--l-2 mg--r-2" }, [
                  _c("p", { staticClass: "text-medium white mg mg--b-1" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.stateWarrantyMaterialSummary.indemnite_gag) +
                        " €"
                    )
                  ]),
                  _c("p", { staticClass: "text-small white" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("warrantySticky.materialList.gag"))
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "material-summary__bottom" }, [
      _c("hr", { staticClass: "separator mg mg--t-6 mg--b-4" }),
      _c(
        "div",
        [
          _c("ma-input-text", {
            attrs: {
              type: "text",
              name: "material-list-email",
              col: "auto",
              icon: "ico-donnes-du-dossier",
              literal: "common.email"
            },
            on: {
              input: function($event) {
                _vm.email = $event
              },
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.sendMail()
              }
            }
          }),
          _c("span", [
            _c(
              "button",
              {
                staticClass: "mainYellow mg mg--r-2",
                attrs: { disabled: !_vm.validMail || _vm.sendingMail },
                on: {
                  click: function($event) {
                    return _vm.sendMail()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("warrantySticky.materialList.send")))]
            )
          ])
        ],
        1
      ),
      _c(
        "button",
        {
          staticClass: "mainBlue mg mg--r-2",
          on: {
            click: function($event) {
              return _vm.getMaterialPdf()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("warrantySticky.materialList.downloadPDF")))]
      ),
      _c(
        "button",
        {
          staticClass: "secondaryBlue",
          on: {
            click: function($event) {
              return _vm.closeModal()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("warrantySticky.materialList.cancel")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }